import { CreateIndicatorFetchProps } from '../../components/Modals/DashboardModal/dashboardModalInterface';
import { displayToast } from '../../components/Toaster/displayToast';

const createIndicatorFetcher = (
    indicator: CreateIndicatorFetchProps,
    dashboardId: string,
    surveyId: string,
    successMessage: string,
    errorMessage: string,
    selectedSchema: string,
) => {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Accept', 'application/json');
    myHeaders.append('Authorization', `Bearer ${localStorage.getItem('token')}`);
    myHeaders.append('X-Selected-Schema', selectedSchema);

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(indicator),
    };

    return fetch(`${process.env.REACT_APP_API_URL}/survey/${surveyId}/dashboard/${dashboardId}/indicator/`, requestOptions)
        .then((response) => {
            if (!response.ok) {
                displayToast(errorMessage, 'error');
            } else {
                displayToast(successMessage, 'success');
            }
        }).catch(() => {
            displayToast(errorMessage, 'error');
        });
};

export default createIndicatorFetcher;
